module.exports = __webpack_public_path__ + "img/62.56c75ac4.jpg";